'use strict';

import { view } from '@/functions';

export default [
    {
        path: '/ai-guardrails',
        name: 'ai-guardrails',
        meta: {
            title: 'AI guardrails',
            scopes: ['read_ai_conversations'],
        },
        component: () => view('ai-guardrails/index'),
    },
];
